import {
  AccessType,
  ClaimscoreResults,
  EntityType,
  SubmissionType,
} from 'services/ClaimscoreApiService/shared/types';

export enum FiltersFormKeys {
  startDate = 'startDate',
  endDate = 'endDate',
  deductionCodes = 'deductionCodes',
  scoreRange = 'scoreRange',
  useRealTimeClaims = 'useRealTimeClaims',
  files = 'files',
  claimscoreResult = 'claimscoreResult',
  submissionType = 'submissionType',
  accessType = 'accessType',
  documentationProvided = 'documentationProvided',
  entityType = 'entityType',
  isOnlineSubmission = 'isOnlineSubmission',
}

export type FiltersFormKeysType = keyof typeof FiltersFormKeys;

export type FiltersForm = {
  startDate?: string;
  endDate?: string;
  deductionCodes?: string[];
  scoreRange?: [number, number];
  useRealTimeClaims?: boolean;
  files?: string[];
  claimscoreResult?: ClaimscoreResults[];
  submissionType?: SubmissionType;
  accessType?: AccessType[];
  documentationProvided?: boolean;
  entityType?: EntityType;
  isOnlineSubmission?: boolean;
};

export enum ExportType {
  Insight = 'insight',
  Raw = 'raw',
}

export type ExportsForm = {
  title?: string;
};

export enum DrawerType {
  'Filter',
  'Export',
  'ShareReport',
  'ScheduleReport',
  'Timeframe',
}
export enum OverviewCardDrawerType {
  PassingClaims,
  FailedClaims,
  NotAnalyzed,
}

export const clearFormValues: FiltersForm = {
  deductionCodes: [],
  useRealTimeClaims: true,
  files: [],
  scoreRange: undefined,
  claimscoreResult: undefined,
  submissionType: undefined,
  accessType: undefined,
  documentationProvided: undefined,
  entityType: undefined,
  isOnlineSubmission: undefined,
};

export enum PermissionsType {
  Organization = 'organization',
  Case = 'case',
}

export enum AccountStatus {
  Active = 'active',
  Pending = 'pending_2fa',
}
